import { render } from "./CompWorkHour.vue?vue&type=template&id=3a40fada"
import script from "./CompWorkHour.vue?vue&type=script&lang=js"
export * from "./CompWorkHour.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__